import React, { Component } from 'react';
import { Spin, Icon, message } from 'antd';
import { getNamesByLanguage } from '../../constants';
import Form from './Form';
import FormOther from './FormOther';
import FooterButton from '../Components/FooterButton';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import dictCache from '../../../../common/dictCache';
import format from '../../../shared/format';
import { getMatchOption } from '../../../shared/selectFn';

let names = {};

function convertListToOptions(list, labelName, valueName) {
    return (list || []).map(i => ({ label: i[labelName], value: i[valueName] }));
}

class Params extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            prevData: [],
            loading: false,
            editable: false,
            areaList: [],
            diseaseList: [],
            byStageList: [],
            medicineTypeList: [],
            IaExpand: true,
            IbExpand: false,
        };
    }

    componentDidMount() {
        const { status, language } = this.props;
        let editable = false;
        if (status === 'add') {
            editable = true;
        }
        this.setState({ editable }, () => {
            this.loadAreaList();
            this.loadMedicineType();
        });
        names = getNamesByLanguage('params', language);
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea)
            .then(cb).catch(error => {
                console.log(error);
            });
        }, res => {
            this.setState({ areaList: res.data || [] });
        });
    }

    loadDiseaseList = () => {
        const { data: { investigationAreaId } } = this.state;
        if (investigationAreaId) {
            Fetch.post(API_URL.common.queryAllDisease, {
                investigationAreaId
            }).then(res => {
                this.setState({ diseaseList: res.data || [] });
            }).catch(error => {
                console.log(error);
            });
        } else {
            this.setState({ diseaseList: [] });
        }
    }

    loadMedicineType = () => {
        Fetch.post(API_URL.personal.queryVitaeList, {
            typeName: 'INVESTIGATION_PRODUCT'
        }).then(res => {
            this.setState({ medicineTypeList: res.vitaeList || [] });
        }).catch(error => {
            console.log(error);
        });
    }

    getStageList = () => {
        const { data: { investigationMedicineType }, medicineTypeList } = this.state;
        if (investigationMedicineType) {
            const { childList } = getMatchOption(medicineTypeList, 'typeName', investigationMedicineType);
            this.setState({ byStageList: childList || [] });
        } else {
            this.setState({ byStageList: [] });
        }
    }
    
    handleChange = ({ value, key }) => {
        const { data } = this.state;
        if (key === 'investigationAreaId') {
            data.investigationAreaId = value;
            data.diseaseId = undefined;
            data.diseaseName = '';
        } else if (key === 'investigationMedicineType') {
            data.investigationMedicineType = value;
            data.investigationByStageId = undefined;
            data.investigationByStageName = '';
        } else {
            data[key] = value;
        }
        this.props.hasChange();
        this.setState({ data }, () => {
            key === 'investigationAreaId' && this.loadDiseaseList();
            key === 'investigationMedicineType' &&  this.getStageList();
        });
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            const { status } = this.props;
            status === 'add' && this.props.changeStep(1);
        }
    }

    handleExpand = (type) => {
        const key = `${type}Expand`;
        this.setState(prevState => ({
            [key]: !prevState[key],
        }));
    }

    getTitle = (type) => {
        const expand = this.state[`${type}Expand`];
        return (
            <div
                style={{ position: 'relative', margin: '0 10px 10px', paddingLeft: 10, fontSize: '14px', lineHeight: '42px', fontWeight: 'bold', background: '#f1f1f1' }}
            >
                {type}期
                <a
                    style={{ position: 'absolute', top: 2, right: 10, fontWeight: 'normal', fontSize: '12px' }}
                    onClick={() => this.handleExpand(type)}
                >
                    {expand ? "收起" : "展开"}
                    <Icon className="expand-icon" style={{ fontSize: '12px' }} type={expand ? "up" : "down"} />
                </a>
            </div>
        );
    }

    toggleEditable = (editable) => {
        this.setState({ editable });
    }

    render() {
        const { status, height, language } = this.props;
        const { data, prevData, loading, editable, IaExpand, IbExpand, areaList, diseaseList, byStageList, medicineTypeList } = this.state;
        const { periodId } = data;
        const showIaIb = periodId === 'Ia+Ib期';
        const options = {
            areaOptions: convertListToOptions(areaList, names.zh ? 'investigationAreaName' : 'englishName', 'investigationAreaId'),
            diseaseOptions: convertListToOptions(diseaseList, names.zh ? 'diseaseName' : 'englishName', 'diseaseId'),
            medicineTypeOptions: convertListToOptions(medicineTypeList, names.zh ? 'chName' : 'enName', 'vitaeDictId'),
            byStageOption: convertListToOptions(byStageList, names.zh ? 'chName' : 'enName', 'vitaeDictId'),
            periodOptions: names.periodOptions,
        };
        const otherOptions = {
            dataCollectionMediumOptions: names.dataCollectionMediumOptions,
            defaultOptions: names.defaultOptions
        };
        return (
            <Spin spinning={loading}>
                <div className="quotation-content paddingBottom10" style={{ height }}>
                    <h2 className="quotation-title">{names.title}</h2>
                    <Form
                        data={data}
                        names={names}
                        options={options}
                        prevData={prevData}
                        // mode="compare"
                        editable={editable}
                        language={language}
                        onChange={this.handleChange}
                        formRef={el => this.formRef = el}
                    />
                    { showIaIb && this.getTitle('Ia') }
                    {
                        IaExpand &&
                        <FormOther
                            data={data}
                            names={names}
                            options={otherOptions}
                            prevData={prevData}
                            // mode="compare"
                            editable={editable}
                            language={language}
                            onChange={this.handleChange}
                            formRef={el => this.formIaRef = el}
                        />
                    }
                    { showIaIb && this.getTitle('Ib') }
                    {
                        IbExpand && showIaIb &&
                        <FormOther
                            data={data}
                            names={names}
                            options={otherOptions}
                            prevData={prevData}
                            // mode="compare"
                            editable={editable}
                            language={language}
                            onChange={this.handleChange}
                            formRef={el => this.formIbRef = el}
                        />
                    }
                </div>
                <FooterButton
                    status={status}
                    editable={editable}
                    confirm={this.confirm}
                    toggleEditable={this.toggleEditable}
                />
            </Spin>
        );
    }
}

export default Params;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Params/index.js